var React = require('react');

function ArrowRightGreen (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M6.6535 0.146447C6.45824 -0.0488155 6.14166 -0.0488155 5.9464 0.146447C5.75114 0.341709 5.75114 0.658291 5.9464 0.853553L9.09226 3.99941H0.699951C0.423809 3.99941 0.199951 4.22327 0.199951 4.49941C0.199951 4.77556 0.423809 4.99941 0.699951 4.99941H9.09343L5.9464 8.14645C5.75114 8.34171 5.75114 8.65829 5.9464 8.85355C6.14166 9.04882 6.45824 9.04882 6.6535 8.85355L10.6535 4.85355C10.8488 4.65829 10.8488 4.34171 10.6535 4.14645L6.6535 0.146447Z","fill":"#008078"}));
}

ArrowRightGreen.defaultProps = {"width":"11","height":"9","viewBox":"0 0 11 9","fill":"none"};

module.exports = ArrowRightGreen;

ArrowRightGreen.default = ArrowRightGreen;
